import React, { useEffect, useRef } from "react";
import axios from "axios";
const $3Dmol = require("3dmol/build/3Dmol-min.js");

export default function ProteinViewer() {
  const molRef = useRef(null);

  const createViewer = async () => {
    let config = {
      showbackground: "false",
      backgroundColor: "0x000000",
    };
    const query = await axios.get(`/notebook/pdb/81_tmalign.pdb`);
    let viewer = $3Dmol.createViewer(molRef.current, config);
    viewer.addModel(query.data, "pdb");
    viewer.setStyle(
      { chain: "A" },
      { cartoon: { style: "oval", color: "0x8D929A" } }
    );
    viewer.setStyle(
      { chain: "C" },
      { cartoon: { style: "oval", color: "0xFF3399" } }
    );
    viewer.setStyle(
      { chain: "D" },
      { cartoon: { style: "oval", color: "0x85DB18" } }
    );
    viewer.setStyle(
      { chain: "E" },
      { cartoon: { style: "oval", color: "0x38AAEA" } }
    );
    viewer.setStyle(
      { chain: "F" },
      { cartoon: { style: "oval", color: "0xFFB800" } }
    );
    // viewer.setStyle({ chain: "F" }, { cartoon: { hidden: true } });
    viewer.setStyle({ chain: "G" }, { cartoon: { hidden: true } });
    viewer.setStyle({ chain: "H" }, { cartoon: { hidden: true } });
    viewer.setStyle({ chain: "I" }, { cartoon: { hidden: true } });
    viewer.setStyle({ chain: "J" }, { cartoon: { hidden: true } });
    viewer.setStyle({ chain: "K" }, { cartoon: { hidden: true } });
    viewer.setStyle({ chain: "B" }, { cartoon: { hidden: true } });
    // viewer.setStyle({}, { stick: { radius: 0.2 } });
    viewer.setZoomLimits(150, 150);
    viewer.spin("y", 0.5);
    viewer.zoomTo();
    viewer.render();
  };
  useEffect(() => {
    createViewer();
  }, []);
  return (
    <div className="w-full flex items-center text-white">
      <div
        id="mol"
        ref={molRef}
        className={` transition-opacity duration-300 relative w-full h-[200px] rounded-xl z-2 p-3`}
      ></div>
    </div>
  );
}
